import axios from 'axios'
import router from '../../router'
export default {
  state: {
		cart: [],
		increaseItem: 1,
		AmountCart: [],
		SubTotalAmount: 0,
		TotalCartPrice: 0,
		DeliveryFee: 0,
		TaxAmount: 0,
		displayDialogSuggestion: false, // display dialog rank total price to limit web setting
		DeliveryNote: '',
		PickupNote: '',
		timeOut: null
  },
  mutations: {
		setdisplayDialogSuggestion (state, payload) {
			state.displayDialogSuggestion = payload
		},
		SET_CHECKOUT_CART (state, list) {

			let payload = list.payload
			let menudetail = payload.menu

			let index = state.AmountCart.findIndex( element => element.id === menudetail.id)

			if (typeof menudetail.qty === 'undefined' && index === -1) {
				menudetail.qty = 1
			}

			let optionPrice = 0

			payload.options.forEach(element => {
				optionPrice += (typeof element.qty === 'undefined') ? Number(element.price) : Number(element.price) * element.qty
			})

			let total_incr_menu = (list.type === 'incr') ? (Number(menudetail.price) + optionPrice) * (menudetail.qty + 1) : (Number(menudetail.price) + optionPrice) * (menudetail.qty - 1)

			state.SubTotalAmount = total_incr_menu
			state.TotalCartPrice = total_incr_menu

			let BranchDetail = payload.branchdetail
			if (BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00') {
				if (!menudetail.isNonVat) {
					state.TaxAmount = parseFloat((state.SubTotalAmount * BranchDetail.tax) / 100)
				}
      	state.TotalCartPrice = parseFloat(state.SubTotalAmount) + parseFloat(state.TaxAmount)
			}

			state.AmountCart.splice(payload.index, 1, { id: menudetail.id,
				name: menudetail.name,
				description: menudetail.description,
				imageUrl: menudetail.imageUrl,
				price: menudetail.price,
				qty: (list.type === 'incr') ? menudetail.qty + 1 : menudetail.qty - 1,
				total: state.TotalCartPrice,
				subtotal: state.SubTotalAmount,
				options: payload.options,
				notaion: menudetail.notaion,
				isNonVat: menudetail.isNonVat
			})

			window.localStorage.setItem('cart-'+ state.branchId, JSON.stringify(state.AmountCart))
		},
		SET_TOTAL_CHECKOUT_PRICE (state, payload) {
			state.TotalCartPrice = 0
			state.SubTotalAmount = 0
			state.TaxAmount = 0
			let AmountCart = payload.amountCart
			let BranchDetail = payload.payload.branchdetail

			AmountCart.forEach((element) => {
				state.TotalCartPrice += element.total
				state.SubTotalAmount += element.subtotal
				if (BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00') {
					if (!element.isNonVat) {
						state.TaxAmount += parseFloat((element.subtotal * BranchDetail.tax) / 100)
					}
				}
			})

			if (BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00') {
				state.TotalCartPrice = parseFloat(state.SubTotalAmount) + parseFloat(state.TaxAmount)
			}

			if (state.timeOut === null || state.timeOut === undefined) {
				state.timeOut = Date()
			}

			window.localStorage.setItem('total-order-'+ state.branchId, JSON.stringify({ subtotal: Number(Number(state.SubTotalAmount).toFixed(2)).toFixed(2), total: Number(Number(state.TotalCartPrice).toFixed(2)).toFixed(2), timeOut: state.timeOut }))
		},
		ADD_MENU_TO_CART (state, payload) {
			let optionPrice = 0

			payload.options.forEach(element => {
				optionPrice += (typeof element.qty === 'undefined') ? Number(element.price) : Number(element.price) * element.qty
			})

			if (state.AmountCart === null) {
				state.AmountCart = []
			}

			if (payload.flag === 'editCart') {
				state.AmountCart.splice(payload.index, 1, {
					id: payload.menu.id,
					name: payload.menu.name,
					description: payload.menu.description,
					imageUrl: payload.menu.imageUrl,
					price: payload.menu.price,
					qty: state.increaseItem,
					total: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
					subtotal: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
					options: payload.options,
					notaion: payload.notaion,
					isNonVat: payload.menu.isNonVat
				})
			} else {
				if (state.AmountCart.length > 0) {
					let index = state.AmountCart.findIndex( element => element.id === payload.menu.id)
					if (index === -1) {
						state.AmountCart.push({
							id: payload.menu.id,
							name: payload.menu.name,
							description: payload.menu.description,
							imageUrl: payload.menu.imageUrl,
							price: payload.menu.price,
							qty: state.increaseItem,
							total: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
							subtotal: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
							options: payload.options,
							notaion: payload.notaion,
							isNonVat: payload.menu.isNonVat
						})
					} else {
						if(state.AmountCart[index].options.length === 0) {
							state.AmountCart.splice(index, 1, { id: payload.menu.id,
								name: payload.menu.name,
								description: payload.menu.description,
								imageUrl: payload.menu.imageUrl,
								price: payload.menu.price,
								qty: state.AmountCart[index].qty + state.increaseItem,
								total: (Number(payload.menu.price) + optionPrice) * (state.AmountCart[index].qty + state.increaseItem),
								subtotal: (Number(payload.menu.price) + optionPrice) * (state.AmountCart[index].qty + state.increaseItem),
								options: payload.options,
								notaion: payload.notaion,
								isNonVat: payload.menu.isNonVat
							})
						} else {
							state.AmountCart.push({
								id: payload.menu.id,
								name: payload.menu.name,
								description: payload.menu.description,
								imageUrl: payload.menu.imageUrl,
								price: payload.menu.price,
								qty: state.increaseItem,
								total: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
								subtotal: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
								options: payload.options,
								notaion: payload.notaion,
								isNonVat: payload.menu.isNonVat
							})
						}
					}
				} else {
					state.AmountCart.push({
						id: payload.menu.id,
						name: payload.menu.name,
						description: payload.menu.description,
						imageUrl: payload.menu.imageUrl,
						price: payload.menu.price,
						qty: state.increaseItem,
						total: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
						subtotal: (Number(payload.menu.price) + optionPrice) * (state.increaseItem),
						options: payload.options,
						notaion: payload.notaion,
						isNonVat: payload.menu.isNonVat
					})
				}
			}
			window.localStorage.setItem('cart-'+ state.branchId, JSON.stringify(state.AmountCart))
		},
		UPDATE_TO_CART (state, payload) {

			let menudetail = payload.menu
			let index = state.cart.findIndex( element => element.id === menudetail.id)

			if (index > -1) {
				state.cart.splice(index, 1)
			} else {
				state.temp_menu_id = menudetail.id
			}

			let optionPrice = 0

			payload.options.forEach(element => {
				optionPrice += (typeof element.qty === 'undefined') ? Number(element.price) : Number(element.price) * element.qty
			})

			let total_incr_menu = (Number(menudetail.price) + optionPrice) * state.increaseItem

			state.TotalCartPrice = total_incr_menu
			state.SubTotalAmount = total_incr_menu

			let BranchDetail = payload.branchdetail
			if (BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00') {
				if (!menudetail.isNonVat) {
					state.TaxAmount = parseFloat((state.SubTotalAmount * BranchDetail.tax) / 100)
				}
      	state.TotalCartPrice = parseFloat(state.SubTotalAmount) + parseFloat(state.TaxAmount)
			}

			state.cart.push({
				id: menudetail.id,
				name: menudetail.name,
				description: menudetail.description,
				imageUrl: menudetail.imageUrl,
				price: state.TotalCartPrice,
				subtotal: state.SubTotalAmount,
				qty: state.increaseItem,
				total: state.TotalCartPrice,
				subtotal: state.SubTotalAmount,
				notaion: payload.notaion,
				isNonVat: menudetail.isNonVat
			})

		},
		CLEAR_CART (state) {
			state.cart = []
			state.AmountCart = []
			state.SubTotalAmount = 0
			state.TotalCartPrice = 0
			state.TaxAmount = 0
			state.timeOut = null
			state.increaseItem = 1
			state.DeliveryNote = ''
			state.PickupNote = ''
			window.localStorage.setItem('cart-'+ state.branchId, JSON.stringify(state.cart))
			window.localStorage.setItem('total-order-'+ state.branchId, JSON.stringify({ subtotal: state.SubTotalAmount, total: state.TotalCartPrice, timeOut: state.timeOut} ))
		}
  },
  actions: {
		resetIncrItem ({state}, payload) {
			state.increaseItem = payload
		},
		IcrQtyToCheckout ({commit, state}, payload) {
			// state.displayDialogSuggestion = false
			commit('SET_CHECKOUT_CART', { payload: payload, type: 'incr' })
			commit('SET_TOTAL_CHECKOUT_PRICE', { payload: payload, amountCart: state.AmountCart })
		},
		DcrQtyToCheckout ({commit, state}, payload) {
			// state.displayDialogSuggestion = false
			commit('SET_CHECKOUT_CART', { payload: payload, type: 'dcr' })
			commit('SET_TOTAL_CHECKOUT_PRICE', { payload: payload, amountCart: state.AmountCart })
		},
    IcrQtyToCart ({state, commit}, payload) {
			// state.displayDialogSuggestion = false
			state.increaseItem = state.increaseItem + 1
			commit('UPDATE_TO_CART', payload)
    },
    DcrQtyToCart ({state, commit}, payload) {
			// state.displayDialogSuggestion = false
			// console.log(state.increaseItem + '=' + (payload.menu.qty - 1))
			if (payload.flag === 'editCart') {
				state.increaseItem = (state.increaseItem === 1) ? payload.menu.qty - 1 : state.increaseItem - 1
			} else {
				state.increaseItem = state.increaseItem - 1
			}
			commit('UPDATE_TO_CART', payload)
		},
		updateOptionToCart ({commit, state}, payload) {
			// state.displayDialogSuggestion = false
			if (payload.flag === 'editCart') {
				state.increaseItem = (state.increaseItem === 1) ? payload.menu.qty : state.increaseItem
			}
			commit('UPDATE_TO_CART', payload)
		},
		addMenuToCart ({commit, state}, payload) {
			if (payload.flag === 'editCart') {
				router.push({ path: `/restaurant/${payload.restaurant_uuid}/${payload.branch_uuid}/checkout` })
			} else {
				router.push({ path: `/restaurant/${payload.restaurant_uuid}/${payload.branch_uuid}` })
			}
			commit('ADD_MENU_TO_CART', payload)
			commit('SET_TOTAL_CHECKOUT_PRICE', { payload: payload, amountCart: state.AmountCart })
		},
		deleteMenuInCart ({state}, payload) {
			let BranchDetail = payload.branchdetail
			let index = payload.index
			let menus = payload.menu
			state.SubTotalAmount = state.SubTotalAmount - menus.subtotal
			state.TotalCartPrice = state.TotalCartPrice - menus.total
			if (BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00') {
				if (!menus.isNonVat) {
					state.TaxAmount = state.TaxAmount - parseFloat((menus.subtotal * BranchDetail.tax) / 100)
				}
				state.TotalCartPrice = parseFloat(state.SubTotalAmount) + parseFloat(state.TaxAmount)
			}
			state.AmountCart.splice(index, 1)
			state.cart.splice(index, 1)
			window.localStorage.setItem('cart-' + state.branchId, JSON.stringify(state.AmountCart))
			if (state.AmountCart.length === 0) {
				state.timeOut = null
			}
			window.localStorage.setItem('total-order-'+ state.branchId, JSON.stringify({ subtotal: Number(Number(state.SubTotalAmount).toFixed(2)).toFixed(2), total: Number(Number(state.TotalCartPrice).toFixed(2)).toFixed(2), timeOut: state.timeOut }))
		},
		deleteSoldOutInCart ({state}, payload) {
			state.AmountCart = []
			state.cart = []
			state.SubTotalAmount = 0
			state.TotalCartPrice = 0
			state.TaxAmount = 0
			let BranchDetail = payload.branchdetail
			let menus = payload.menu
			menus.forEach((element) => {
				console.log(element)
				if (!element.is_sold_out) {
					state.AmountCart.push(element)
					state.cart.push(element)
					state.SubTotalAmount += element.subtotal
					state.TotalCartPrice += element.total
					if (BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00') {
						if (!element.isNonVat) {
							state.TaxAmount = parseFloat((state.SubTotalAmount * BranchDetail.tax) / 100)
						}
						state.TotalCartPrice = parseFloat(state.SubTotalAmount) + parseFloat(state.TaxAmount)
					}
				}
			})
			window.localStorage.setItem('cart-' + state.branchId, JSON.stringify(state.AmountCart))
			if (state.AmountCart.length === 0) {
				state.timeOut = null
			}
			window.localStorage.setItem('total-order-'+ state.branchId, JSON.stringify({ subtotal: Number(Number(state.SubTotalAmount).toFixed(2)).toFixed(2), total: Number(Number(state.TotalCartPrice).toFixed(2)).toFixed(2), timeOut: state.timeOut }))
		},
		getQtyMenu ({state}, index) {
			let menu = {
				qty: state.AmountCart[index].qty,
				subtotal: state.AmountCart[index].subtotal
			}
			return menu
		},
		setLocalStorageToCart ({state, commit}, payload) {
      try {
				state.branchId = payload.id
				let cartLocalStorageCart = JSON.parse(localStorage.getItem('cart-' + payload.id))
				let TotalLocalStorageCart = JSON.parse(localStorage.getItem('total-order-' + payload.id))
        if (cartLocalStorageCart !== null) {
          if (cartLocalStorageCart.length > 0) {
						state.TaxAmount = 0
						state.AmountCart = cartLocalStorageCart
						state.SubTotalAmount = TotalLocalStorageCart.subtotal
						state.timeOut = TotalLocalStorageCart.timeOut
						state.DeliveryFee = Number(payload.deliveryFee)
						state.AmountCart.forEach((element) => {
							if (payload.taxType == 'Exclude' && payload.tax != '0.00') {
								if (!element.isNonVat) {
									state.TaxAmount += parseFloat((element.subtotal * payload.tax) / 100)
								}
							}
						})
						if (!(state.timeOut === undefined || state.timeOut === null)) {
							let TimeOrder = new Date(state.timeOut)
							let Now = new Date(Date())
							if (!(TimeOrder.getDate() === Now.getDate() && TimeOrder.getMonth() === Now.getMonth() && TimeOrder.getFullYear() === Now.getFullYear())) {
								commit('CLEAR_CART')
							}
						}
						state.TotalCartPrice = parseFloat(state.SubTotalAmount) + parseFloat(state.TaxAmount)
          } else {
						commit('CLEAR_CART')
          }
        } else {
					state.cart = []
					state.AmountCart = []
					state.displayDialogSuggestion = false
					state.SubTotalAmount = 0
					state.TotalCartPrice = 0
					state.TaxAmount = 0
					state.increaseItem = 1
					window.localStorage.setItem('cart-'+ state.branchId, JSON.stringify(state.cart))
					window.localStorage.setItem('total-order-'+ state.branchId, JSON.stringify({ subtotal: state.SubTotalAmount, total: state.TotalCartPrice, timeOut: null} ))
				}

      } catch (e) {
        commit('CLEAR_CART')
      }
		},
		clearCart ({commit}) {
			commit('CLEAR_CART')
		},
		getCart ({state}, cart) {
			state.AmountCart = cart
		},
		setDeliveryNote ({state}, payload) {
			state.DeliveryNote = payload
		},
		setPickupNote ({state}, payload) {
			state.PickupNote = payload
		}
  },
  getters: {
		cart (state) {
			return state.cart
		},
		branchId (state) {
			return state.branchId
		},
		increaseItem (state) {
			return state.increaseItem
		},
		AmountCart (state) {
			return state.AmountCart
		},
		SubTotalAmount (state) {
			return Number(state.SubTotalAmount)
		},
		TotalCartPrice (state) {
			return Number(state.TotalCartPrice)
		},
		TaxAmount (state) {
			return Number(state.TaxAmount)
		},
		DeliveryFee (state) {
			return state.DeliveryFee
		},
		displayDialogSuggestion (state) {
			return state.displayDialogSuggestion
		},
		DeliveryNote (state) {
			return state.DeliveryNote
		},
		PickupNote (state) {
			return state.PickupNote
		},
		timeOut(state) {
			return state.timeOut
		}
  }
}


// WEBPACK FOOTER //
// ./src/store/cart/index.js